import { useState } from 'react';
import { faqs } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white">
      <div className="section-padding">
        <SectionHeading
          index="07"
          eyebrow="常见问题"
          title="你可能想了解"
          subtitle="关于下载、使用与更新，这里有你想要的答案。"
        />

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <ScrollReveal key={faq.q} delay={i * 40}>
                <div
                  className={`rounded-lg border-2 border-gray-900 bg-white overflow-hidden transition-all duration-300 ${
                    isOpen ? 'shadow-[4px_4px_0_0_#ff9db8]' : 'shadow-[3px_3px_0_0_#e5e7eb]'
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left group"
                  >
                    <h3 className="text-base font-bold text-gray-900 group-hover:text-pink-500 transition-colors pr-6">
                      {faq.q}
                    </h3>
                    <span
                      className={`flex-shrink-0 w-8 h-8 rounded-md border-2 flex items-center justify-center transition-all duration-300 ${
                        isOpen
                          ? 'border-gray-900 bg-pink-500 text-white rotate-45'
                          : 'border-gray-900 bg-white text-gray-700'
                      }`}
                    >
                      <i className="ri-add-line text-lg" />
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? 'max-h-40 pb-6 px-6' : 'max-h-0'
                    }`}
                  >
                    <p className="text-sm text-gray-500 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}